import ReferralTree from "@/pages/admin/ReferralTree";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

function LedgerLine({ l }) {
  const pClass = l.points >= 0 ? "text-emerald-400" : "text-red-400";
  const sign = l.points >= 0 ? "+" : "";
  return (
    <div className="flex items-center justify-between py-2 border-b border-white/5 text-sm">
      <div>
        <div className="text-white">{l.type}</div>
        <div className="text-xs text-slate-500">{l.reference_label}</div>
      </div>
      <div className={`font-mono ${pClass}`}>{sign}{l.points}</div>
    </div>
  );
}

export default function UserDetailDialog({ detail, chain, onClose }) {
  const open = !!detail;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#22103F] border-white/10 text-white max-w-3xl max-h-[90vh] overflow-y-auto">
        {detail ? (
          <div>
            <DialogHeader><DialogTitle className="text-2xl font-light">{detail.user.name}</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
              <div className="velo-surface p-4 rounded-lg">
                <div className="text-xs text-slate-500 uppercase">Phone</div>
                <div className="text-sm text-white font-mono mt-1">{detail.user.phone}</div>
              </div>
              <div className="velo-surface p-4 rounded-lg border border-pink-500/30 bg-pink-500/5">
                <div className="text-xs text-pink-400 uppercase tracking-wider">Login code</div>
                <div data-testid="user-login-code" className="text-sm text-white font-mono mt-1 tracking-wider">{detail.user.login_code || detail.user.referral_base || "—"}</div>
              </div>
              <div className="velo-surface p-4 rounded-lg">
                <div className="text-xs text-slate-500 uppercase">Balance</div>
                <div className="text-sm text-white font-mono mt-1">{detail.user.points_balance} pts</div>
              </div>
              <div className="velo-surface p-4 rounded-lg">
                <div className="text-xs text-slate-500 uppercase">Pending refs</div>
                <div className="text-sm text-white font-mono mt-1">{detail.pending_referrals ?? 0}</div>
              </div>
            </div>

            {detail.user.role === "affiliate" ? (
              <div className="mt-6 velo-surface p-4 rounded-lg border border-pink-500/20">
                <div className="text-xs text-pink-400 uppercase tracking-wider mb-3">Bank on file · for cash payouts</div>
                {detail.user.bank_details ? (
                  <div data-testid="user-bank-details" className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                    <div>
                      <div className="text-[11px] text-slate-500 uppercase tracking-wider">Account holder</div>
                      <div className="text-white mt-0.5">{detail.user.bank_details.account_holder}</div>
                    </div>
                    <div>
                      <div className="text-[11px] text-slate-500 uppercase tracking-wider">Bank name</div>
                      <div className="text-white mt-0.5">{detail.user.bank_details.bank_name}</div>
                    </div>
                    <div>
                      <div className="text-[11px] text-slate-500 uppercase tracking-wider">Account number</div>
                      <div className="text-white font-mono mt-0.5">{detail.user.bank_details.account_number}</div>
                    </div>
                    <div>
                      <div className="text-[11px] text-slate-500 uppercase tracking-wider">IFSC</div>
                      <div className="text-white font-mono mt-0.5">{detail.user.bank_details.ifsc}</div>
                    </div>
                  </div>
                ) : (
                  <div data-testid="user-bank-details-empty" className="text-sm text-amber-400">Not added yet — the affiliate will see a reminder on every login until they save it.</div>
                )}
              </div>
            ) : null}
            <div className="mt-6">
              <div className="text-xs text-slate-500 uppercase tracking-wider mb-3">Referral chain</div>
              <ReferralTree root={chain} />
            </div>
            <div className="mt-6">
              <div className="text-xs text-slate-500 uppercase tracking-wider mb-3">Ledger ({detail.ledger.length})</div>
              <div className="space-y-1 max-h-64 overflow-y-auto">
                {detail.ledger.map((l) => <LedgerLine key={l.id} l={l} />)}
              </div>
            </div>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
